module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-telephone","title":"手机号","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-telephone/package.json
// module id = 598
// module chunks = 2